import React, { Fragment } from "react";
import "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../actions/auth";
import "./jnav.css";

const Navbar = ({ auth: { isAuthenticated, loading, user }, logout }) => {
	const authLinks = (
		<div className="handlinner">
			<div className="jnitem">
				<Link
					to="/dashboard"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "5px"
					}}
				>
					<i className="fas fa-user" style={{ marginRight: "10px" }} />{" "}
					<span>Home</span>
				</Link>
				
			</div>
			{/* <div className="jnitem">
			<Link
					to="/checkstatus"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "5px"
					}}
				>
					<i className="fas fa-user" style={{ marginRight: "10px" }} />{" "}
					<span>Applications</span>
				</Link>
				</div> */}
			<div className="jnitem">
				<a
					onClick={logout}
					href="/"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "5px"
					}}
				>
					<i className="fas fa-sign-out-alt" style={{ marginRight: "10px" }} />
					<span>Logout</span>
				</a>
			</div>
		</div>
	);

	const verlinks = (
		<div style={{ display: "flex", flexDirection: "row", flex: "1" }}>
			<div
				style={{ fontWeight: "bolder", fontSize: "12pt" }}
				className="jnitem"
			>
				<Link
					to="/dashboard"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "5px"
					}}
				>
					<i className="fas fa-user" style={{ color: "white" }} />{" "}
					<span style={{ color: "white" }}>Home</span>
				</Link>
			</div>

			{/* <div className="jnitem">
			<Link
					to="/checkstatus"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "2px"
					}}
				>
					<i className="fas fa-user" style={{ marginRight: "10px" }} />{" "}
					<span>Applications</span>
				</Link>
				</div> */}

			<div className="jnitem">
				<div
					onClick={logout}
					href="#!"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "5px"
					}}
				>
					<i className="fas fa-sign-out-alt" /> <span>Logout</span>
				</div>
			</div>
		</div>
	);

	const guestLinks = (
		<div className="login">
			<Link
				to="/login"
				style={{
					color: "white",
					textDecoration: "none",
					backgroundColor: "#1890ff",
					padding: "3px 18px",
					borderRadius: "5px"
				}}
			>
				<i
					class="fa-solid fa-right-to-bracket"
					style={{ marginRight: "10px" }}
				></i>
				Login
			</Link>
		</div>
	);

	const coordLinks = (
		<>
			<div className="jnitem">
				<Link to="/dashboard" style={{ color: "white" }}>
					Home
				</Link>
			</div>
			<div className="jnitem">
				<Link to="/dload" style={{ color: "white" }}>
					Download Certificates
				</Link>
			</div>
			{/* <div className="jnitem">
				<Link to="/report" style={{ color: "white" }}>
					Reports
				</Link>
			</div> */}
			<div className="jnitem">
				<a
					onClick={logout}
					href="/"
					style={{
						color: "white",
						textDecoration: "none",
						backgroundColor: "#1890ff",
						padding: "3px 18px",
						borderRadius: "5px"
					}}
				>
					<i className="fas fa-sign-out-alt" style={{ marginRight: "10px" }} />
					<span>Logout</span>
				</a>
			</div>
		</>
	);

	return (
		<nav className="jnav">
			<div className="jnitem">
				<img
					src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/TamilNadu_Logo.svg/1092px-TamilNadu_Logo.svg.png?20130806083435"
					alt=""
					style={{ height: "auto", width: "45px", marginRight: "10px" }}
				/>
				TNGASA 2026
			</div>
			<div className="jnitem">
				<Link
					to="/"
					style={{
						color: "white",
						// fontSize: "25px",
						textDecoration: "none"
						// fontWeight: "bold"
					}}
				>
					B.Ed Admissions
				</Link>
			</div>

			{!loading && (
				<Fragment>
					{isAuthenticated
						? user && user.ltype === "C"
							? coordLinks
							: user && user.ltype === "U"
							? verlinks
							: authLinks
						: guestLinks}
				</Fragment>
			)}
		</nav>
	);
};

Navbar.propTypes = {
	logout: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	auth: state.auth
});

export default connect(mapStateToProps, { logout })(Navbar);
